import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '40px'
  },
  title: {
    fontSize: '18px',
    color: theme.palette.black.dark,
    fontWeight: 600
  },
  results: {
    fontSize: '12px',
    color: theme.palette.grey.grey200,
    fontWeight: 600,
    marginLeft: '10px'
  },
  associateAdded: {
    color: 'white',
    marginLeft: '5px',
    fontSize: '12px',
    fontWeight: 600
  },
  associateToAdd: {
    color: theme.palette.primary.main,
    marginLeft: '5px',
    fontSize: '12px',
    fontWeight: 600
  },

}));

export default useStyles;
